// const servidor = "http://localhost:3000";
const servidor = "https://api-pass-cass.vercel.app";

export const environment = {
  production: false,
  login: `${servidor}/auth/login`,
  rotaEmpresas: `${servidor}/empresas`,
  rotaUsuarios: `${servidor}/users`,
  rotaResetPasswordUsuarios: `${servidor}/users/reset-password`,
  rotaConsultores: `${servidor}/consultores`,
  rotaGuias: `${servidor}/guias`,
  relatorios: `${servidor}/relatorios`,
  rotaProcedimentos: `${servidor}/procedimentos`,
  rotaTipos: `${servidor}/tipos`,
  saveFcmToken: `${servidor}/push/token`,
  sendToken: `${servidor}/push/send`,
  sendPush: `${servidor}/push`,
  sendConfirmaAgendamento: `${servidor}/push/sendConfirmaAgendamento`,
  sendAgendamento: `${servidor}/push/sendAgendamento`,
  reset_password: `${servidor}/empresas/reset-password`,
  sendEmail: `${servidor}/send-email`,
  firebase: {
    apiKey: "AIzaSyCUCOyO3xAwys-kh7w3a5EKUml04Nn0NYs",
    authDomain: "cartao-pass.firebaseapp.com",
    projectId: "cartao-pass",
    storageBucket: "cartao-pass.appspot.com",
    messagingSenderId: "417410212514",
    appId: "1:417410212514:web:6a6243b1941ff58f8f6dfb",
    measurementId: "G-J39Z5VTQZZ",
    vapidKey:
      "BCCQNn2kIoWU8OWvTYFQ7t89vi8jC2FG-uwL9o3wzeVXLBStyEDA2JD4AnwXBgOU651ph8FgYvSVqa8aruC4ojk",
  },
};
